import { Magnetic } from '@/components/Magnetic';
import { Meta } from '@/components/Meta';
import { Reveal } from '@/components/Reveal';
import { pasticceria } from '@/data/creazioni';

// Demo: un provider no-backend (Formspree/Web3Forms) va qui.
const FORM_ENDPOINT = 'https://formspree.io/f/your-id';

export function ContactPage() {
  return (
    <>
      <Meta title="Ordina una torta — Rachele Dolcezze" description="Richiedi la tua torta personalizzata a Rachele Dolcezze, Travedona Monate." />

      <header className="u-container pt-[22vh] pb-12">
        <p className="eyebrow text-blush-deep">Su ordinazione</p>
        <h1 className="mt-5 font-display text-6xl md:text-8xl">Ordina una torta</h1>
        <p className="mt-8 max-w-xl text-lg leading-relaxed text-ink-soft">
          Raccontaci la tua idea: occasione, data, numero di persone e gusto. Ti ricontattiamo per
          confermare ogni dettaglio.
        </p>
      </header>

      <div className="u-container grid gap-14 pb-[16vh] md:grid-cols-12">
        <Reveal className="md:col-span-7">
          <form action={FORM_ENDPOINT} method="POST" className="space-y-6 rounded-sm bg-cream-deep p-8 md:p-10">
            <Field name="nome" label="Nome" type="text" autoComplete="name" />
            <Field name="email" label="Email o telefono" type="text" autoComplete="email" />
            <div className="grid gap-6 sm:grid-cols-2">
              <Field name="occasione" label="Occasione" type="text" />
              <Field name="data" label="Data dell'evento" type="date" />
            </div>
            <div className="grid gap-6 sm:grid-cols-2">
              <Field name="persone" label="Numero di persone" type="number" />
              <Field name="gusto" label="Gusto preferito" type="text" />
            </div>
            <div>
              <label htmlFor="dettagli" className="eyebrow mb-2 block text-ink-soft">
                Raccontaci la tua idea
              </label>
              <textarea
                id="dettagli"
                name="dettagli"
                rows={4}
                className="w-full resize-none border-b border-ink/30 bg-transparent py-2 text-lg outline-none transition-colors focus:border-sage-deep"
              />
            </div>
            <Magnetic className="inline-block">
              <button
                type="submit"
                className="inline-flex items-center gap-3 rounded-full bg-sage-deep px-8 py-3.5 text-xs uppercase tracking-[0.2em] text-cream transition-opacity hover:opacity-90"
              >
                Invia la richiesta <span aria-hidden>→</span>
              </button>
            </Magnetic>
          </form>
        </Reveal>

        <aside className="space-y-8 md:col-span-4 md:col-start-9">
          <div>
            <p className="eyebrow mb-3 text-ink-soft">Più veloce su</p>
            <a href={pasticceria.whatsapp} target="_blank" rel="noopener noreferrer" className="link-line text-lg">
              WhatsApp
            </a>
          </div>
          <div>
            <p className="eyebrow mb-3 text-ink-soft">Seguici</p>
            <a href={pasticceria.instagram} target="_blank" rel="noopener noreferrer" className="link-line text-lg">
              @racheledolcezze
            </a>
          </div>
          <div>
            <p className="eyebrow mb-3 text-ink-soft">Dove siamo</p>
            <p className="text-lg leading-relaxed">{pasticceria.indirizzo}</p>
          </div>
        </aside>
      </div>
    </>
  );
}

function Field({ name, label, type, autoComplete }: { name: string; label: string; type: string; autoComplete?: string }) {
  return (
    <div>
      <label htmlFor={name} className="eyebrow mb-2 block text-ink-soft">
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        autoComplete={autoComplete}
        className="w-full border-b border-ink/30 bg-transparent py-2 text-lg outline-none transition-colors focus:border-sage-deep"
      />
    </div>
  );
}
